import React from 'react';
import './RoundIconButton.css';
import IconButton from '@mui/material/IconButton';
import { alpha, useTheme } from '@mui/material/styles';

interface RoundIconButtonProps {
    icon: React.ReactNode;
    helperText: string;
    size: 'small' | 'medium' | 'verysmall';
    color?: 'secondary-color' | 'primary-color' | 'on-secondary-color' | 'on-primary-color' | string;
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

/**
 * RoundIconButton component.
 *
 * @param icon - The icon.
 * @param helperText - The helper text.
 * @param size - The size of the button.
 * @param color - The color of the button.
 * @param onClick - The click event handler.
 * @returns A JSX.Element representing the RoundIconButton component.
 */
function RoundIconButton({ icon, helperText, size, color = 'var(--color-primary)', onClick }: RoundIconButtonProps) {
    const theme = useTheme();
    const iconButtonSize = size === 'verysmall' ? 'small' : size;

    return (
        <div className="roundIconButton">
            <IconButton
                size={iconButtonSize}
                title={helperText}
                sx={{
                    color: color.includes('-color') ? `var(--var-${color})` : color,
                    padding: size === 'verysmall' ? 0 : 'initial',
                    '&:hover': {
                        bgcolor: alpha(theme.palette.primary.main, 0.2),
                    },
                }}
                onClick={(ev) => {
                    ev.preventDefault();
                    onClick(ev);
                }}
            >
                {icon}
            </IconButton>
        </div>
    );
}

export default RoundIconButton;
